import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './ArrowIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const ArrowIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function ArrowIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 16 13" component={Icon} {...props} />
  );
});
